module.exports = __webpack_public_path__ + "static/media/bg.19b82faf.png";